export default __webpack_public_path__ + "static/media/icon1.edb2fa5a.png";